// Cancelled trips are counted here but excluded from the returned
// listTrips — they're never shown in the results table itself.
export const computeTripStats = (tripList) => {
  const listTrips = [];
  let totalMileage = 0;
  let totalRate = 0;
  let completedCount = 0;
  let noShowCount = 0;
  let cancelledCount = 0;

  tripList.forEach((t) => {
    if (t.status === "Canceled") {
      cancelledCount++;
      return;
    }
    listTrips.push(t);
    totalMileage += parseFloat(t.miles) || 0;
    totalRate += t.rate || 0;
    if (t.status === "Completed") completedCount++;
    if (t.status === "NoShow") noShowCount++;
  });

  return { listTrips, totalMileage, totalRate, completedCount, noShowCount, cancelledCount };
};
